import { render } from "./table-view.vue?vue&type=template&id=9e9e5e7c"
import script from "./table-view.vue?vue&type=script&lang=ts"
export * from "./table-view.vue?vue&type=script&lang=ts"

import "./table-view.vue?vue&type=style&index=0&id=9e9e5e7c&lang=less"
script.render = render

export default script